import script from "./ui-select-country.vue?vue&type=script&setup=true&lang=ts"
export * from "./ui-select-country.vue?vue&type=script&setup=true&lang=ts"

import "./ui-select-country.vue?vue&type=style&index=0&id=e441f3a0&lang=less"

const __exports__ = script;

export default __exports__